import './footer.css'
import { Social } from '../social-media/social-media';
const Footer = () => {
    return (
        <div className="footer">
            <div className="footer-main">
                <div className="footer-div">
                    <h4> Residence </h4>
                    <p>  I'm living in the USA ;I'm a young developer passionate about building smart, clean, and user-friendly applications.  </p>
                </div>
                <div className="footer-div">
                    <h4> Services </h4>
                    <ul className='footer-ul'> <li>Initial Consultation</li>
                        <li> Project Follow-up</li>
                        <li> Technical Meeting</li>
                        <li> Product Demo </li>
                        <li>and more...</li></ul>
                </div>
                <div className="footer-div">
                    <h4> Skills </h4>
                   <ul className='footer-ul'> <li>Html & Css</li>
                        <li> Javascript</li>
                        <li>Node Js & React Js</li>
                        <li> Python</li>
                        <li>Django</li>
                        <li>Photoshop</li>
                        <li>Microsoft Offices</li>
                        <li>and more ...</li></ul>
                </div>
                <div className="footer-div">
                    <h4> Sociaux medias </h4>
                    <p>    <Social /></p>
                </div>
            </div>
            <div className="footer-link">
                
                <p> © 2025 created by roger alfani aka win alfani   </p>
            </div>
        </div>

    )
};

export default Footer;